import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getMiniProgramGovList = (payload, callback) =>
  req.list(
    c.GET_MINI_PROGRAM_GOV,
    'api/v1/administrators/mini_program_goverments',
    payload,
    callback
  );

export const showMiniProgramGov = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_MINI_PROGRAM_GOV,
    `api/v1/administrators/mini_program_goverments/${id}`,
    payload,
    callback
  );

export const createMiniProgramGov = (payload, callback) =>
  req.create(
    c.CREATE_MINI_PROGRAM_GOV,
    'api/v1/administrators/mini_program_goverments',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMiniProgramGov = (id, payload, callback) =>
  req.update(
    c.UPDATE_MINI_PROGRAM_GOV,
    `api/v1/administrators/mini_program_goverments/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeMiniProgramGov = (id, payload, callback) =>
  req.remove(
    c.REMOVE_MINI_PROGRAM_GOV,
    `api/v1/administrators/mini_program_goverments/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Untag !');
      if (callback) callback();
    }
  );